"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.1.0
 */
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var dynamic_portfolio_service_1 = require("./dynamic-portfolio.service");
var Observable_1 = require("rxjs/Observable");
var services_1 = require("../../services");
require("./portfolio.component.scss");
/**
 *
 * @implements {OnInit, OnDestroy}
 */
var DynamicPortfolioComponent = /** @class */ (function () {
    function DynamicPortfolioComponent(dynamicPortfolioService, extractionService) {
        this.dynamicPortfolioService = dynamicPortfolioService;
        this.extractionService = extractionService;
        // Expose enums to use in template.
        this.metaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        /**
         *
         * @type {number}
         * @default
         */
        this.formId = 0;
        /**
         * Number of rows to render in portfolio.
         * @type {number}
         */
        this.pageLimit = 0;
        /**
         * Indicator for current portfolio page.
         * @type {number}
         * @default
         * @protected
         */
        this._currentPage = 0;
        /**
         * Is used to init view after all needed info is loaded.
         * @type {boolean}
         * @default
         * @protected
         */
        this._isReady = false;
        // Properties and accessors for sorting components. Don't delete them.
        this._sortField = undefined;
        this._isAscending = false;
        this._notificationBoxVisibility = false;
    }
    Object.defineProperty(DynamicPortfolioComponent.prototype, "sortField", {
        get: function () {
            return this._sortField;
        },
        set: function (value) {
            this._sortField = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "isAscending", {
        get: function () {
            return this._isAscending;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (currentPage) {
            this._currentPage = currentPage;
            this.dynamicPortfolioService.updatePortfolio(new idm_de_core_frontend_1.PagingOptions(this._currentPage, this.pageLimit));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "totalItemsCount", {
        get: function () {
            return this.dynamicPortfolioService.totalItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "pageTotalCount", {
        get: function () {
            return this.dynamicPortfolioService.pageTotalCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "portfolioColumns", {
        get: function () {
            return this.dynamicPortfolioService.portfolioColumns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "portfolioRows", {
        get: function () {
            return this.dynamicPortfolioService.portfolioRows;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioComponent.prototype, "notificationBoxVisibility", {
        get: function () {
            return this._notificationBoxVisibility;
        },
        enumerable: true,
        configurable: true
    });
    DynamicPortfolioComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.portfolioInit$ = this.dynamicPortfolioService
            .initFor(this.categorySystemName, this.columnSystemNames, this.pageLimit, this.filterKeys, this.defaultFilter, this.categoryPermissions)
            .subscribe(function () {
            _this._isReady = true;
        }, function (err) { return console.error(err); });
    };
    DynamicPortfolioComponent.prototype.ngOnDestroy = function () {
        this.portfolioInit$.unsubscribe();
    };
    /**
     * Function used by sorting components.
     * @param {string} sortField
     * @param {boolean} sortAscending
     */
    DynamicPortfolioComponent.prototype.changeSorting = function (sortField, sortAscending) {
        this._currentPage = 0;
        this._sortField = sortField;
        this._isAscending = sortAscending;
        var sortType = this._isAscending ? idm_de_core_frontend_1.SortType.ASC : idm_de_core_frontend_1.SortType.DESC;
        this.dynamicPortfolioService.sortingOptions = new idm_de_core_frontend_1.SortingOptions(sortField, sortType);
        this.dynamicPortfolioService.updatePortfolio(new idm_de_core_frontend_1.PagingOptions(this._currentPage, this.pageLimit));
    };
    /**
     * Navigates to date entry form.
     * @param {PortfolioRowModel} entityRow
     */
    DynamicPortfolioComponent.prototype.navigateToDeForm = function (entityRow) {
        var _this = this;
        this.dynamicPortfolioService.navigateToDeForm(entityRow.entityInstanceId, this.deFormName, this.formId)
            .filter(function (value) { return value; })
            .subscribe(function () {
            _this._notificationBoxVisibility = true;
            setTimeout(function () { return _this._notificationBoxVisibility = false; }, 3500);
        }, console.error);
    };
    /**
     * Gets name from nameMetaFields.
     * @param {any} value
     * @returns {string}
     */
    DynamicPortfolioComponent.prototype.getNameMeasure = function (value) {
        if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            return value.getValue(this.dynamicPortfolioService.currentLanguageId);
        }
        return value;
    };
    /**
     * Gets sort field name from {@link columnSystemNames}.
     * @param {MetaField} metaField
     * @returns {string}
     */
    DynamicPortfolioComponent.prototype.getSortField = function (metaField) {
        return this.dynamicPortfolioService.searchNames.get(metaField.getSystemName());
    };
    /**
     * Extracts {@link MainEntity} value to display in portfolio.
     * @param {MainEntity} mainEntity
     * @returns {number}
     */
    DynamicPortfolioComponent.prototype.extractMainEntityValue = function (mainEntity) {
        return mainEntity && mainEntity.getInstanceId();
    };
    /**
     * Extracts {@link MainEntity} value considering that it is classifier.
     * Value for classifier considered to be its name.
     * @param {MainEntity} classifier
     * @param compoundCategorySystemName classifier's type
     * @returns Observable{string}
     */
    DynamicPortfolioComponent.prototype.extractClassifier = function (classifier, compoundCategorySystemName) {
        return this.extractionService.extractNameFromClassifier(classifier, compoundCategorySystemName, this.dynamicPortfolioService.currentLanguageId);
    };
    DynamicPortfolioComponent.prototype.extractMultiselect = function (classifiers, compoundSystemName) {
        return (!classifiers || classifiers.length === 0) ? Observable_1.Observable.of('') :
            this.extractionService.extractNameFromMultiSelect(classifiers, compoundSystemName, this.dynamicPortfolioService.currentLanguageId);
    };
    /**
     * Extracts {@link MultilingualString} value with {@link currentLanguage} to display in portfolio.
     * @param {MultilingualString} mlString
     * @returns {string}
     */
    DynamicPortfolioComponent.prototype.extractMultilingualString = function (mlString) {
        return mlString.getValue(this.dynamicPortfolioService.currentLanguageId);
    };
    DynamicPortfolioComponent.prototype.extractImageDocument = function (documentId, instanceId, documentSystemName) {
        return this.extractionService.extractImageDocument(documentId, instanceId, this.categorySystemName, documentSystemName.getSystemName());
    };
    DynamicPortfolioComponent.prototype.getCellId = function (row, index) {
        return this.id + '-' + row.entityInstanceId + '-' + index;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicPortfolioComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicPortfolioComponent.prototype, "baseUrl", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicPortfolioComponent.prototype, "categorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DynamicPortfolioComponent.prototype, "columnSystemNames", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicPortfolioComponent.prototype, "deFormName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicPortfolioComponent.prototype, "formId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DynamicPortfolioComponent.prototype, "filterKeys", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.FilterCriteria)
    ], DynamicPortfolioComponent.prototype, "defaultFilter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DynamicPortfolioComponent.prototype, "pageLimit", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DynamicPortfolioComponent.prototype, "categoryPermissions", void 0);
    DynamicPortfolioComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            providers: [dynamic_portfolio_service_1.DynamicPortfolioService],
            selector: 'dynamic-portfolio',
            template: require('./portfolio.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <dynamic-portfolio\n            [id]=\"'%{id}'\"\n            [categorySystemName]=\"'%{categorySystemName}'\"\n            [columnSystemNames]=\"%{columnSystemNames}\"\n            [deFormName]=\"'%{deFormName}'\"\n            [pageLimit]=\"'%{pageLimit}'\"\n            [filterKeys]=\"%{filterKeys}\"\n            %{#defaultFilter} [defaultFilter]=\"%{defaultFilter}\" %{/defaultFilter}>\n        </dynamic-portfolio>\n    ",
        }),
        __metadata("design:paramtypes", [dynamic_portfolio_service_1.DynamicPortfolioService,
            services_1.ExtractionService])
    ], DynamicPortfolioComponent);
    return DynamicPortfolioComponent;
}());
exports.DynamicPortfolioComponent = DynamicPortfolioComponent;
//# sourceMappingURL=portfolio.component.js.map